import { AuthAccessWriteScope } from "@t3tools/contracts";
import type { ClientSettings } from "@t3tools/contracts/settings";

import { usePrimarySessionState } from "~/environments/primary";
import { useSettings } from "~/hooks/useSettings";

const selectDeveloperView = (settings: ClientSettings) => settings.developerView;

/** Whether the session is an administrator's; the administrator settings decide what it shows. */
export function useInspectScope(): {
  hasScope: boolean;
  isPending: boolean;
} {
  const primarySessionState = usePrimarySessionState();
  const data = primarySessionState.data;
  if (!data) {
    return { hasScope: false, isPending: primarySessionState.isPending };
  }
  const scopes = data.authenticated ? (data.scopes ?? null) : null;
  return {
    hasScope: scopes?.includes(AuthAccessWriteScope) ?? false,
    isPending: false,
  };
}

export function useInspectAccess(): {
  hasAccess: boolean;
  isPending: boolean;
} {
  const { hasScope, isPending } = useInspectScope();
  const developerView = useSettings(selectDeveloperView);
  return { hasAccess: hasScope && developerView, isPending };
}
